import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '@env/environment';
import { ResyncDialogComponent } from './resync-dialog/resync-dialog.component';
import { AmplifyService } from 'app/aws/amplify.service';
import { v4 as uuidv4 } from 'uuid';
import { FetchMessageService } from './resync-dialog/fetch-message.service';
import { NotificationsService } from '@common/notifications/notifications.service';
import { ColorType } from '@gravity-angular/models';
import { BaseModule } from '@gravity-angular/base';
import { ComponentsModule } from '@gravity-angular/components';
import { IframeComponent } from 'app/shared/iframe/iframe.component';

@Component({
  selector: 'app-gso-ami-saas',
  templateUrl: './gso-ami-saas.component.html',
  styleUrls: ['./gso-ami-saas.component.scss'],
  standalone: true,
  imports: [BaseModule, ComponentsModule, IframeComponent]
})
export class GSOAMISAASComponent implements OnInit, OnDestroy {
  url: string;
  showProgressbar: boolean = false;
  private intervalId: any;

  constructor(
    private dialog: MatDialog,
    private amplifyService: AmplifyService,
    private fetchMessageService: FetchMessageService,
    private readonly notificationsService: NotificationsService
  ) {}

  ngOnInit(): void {
    this.url = environment.GSOAMISaaSDashboard;
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  resyncMsData(): void {
    const dialogRef = this.dialog.open(ResyncDialogComponent, {
      width: '400px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('Selected Month/Year:', result);

        const uuid = uuidv4(); // Generate a unique identifier
        const config = {
          body: {
            monthYear: result,
            uuid: uuid,
            status: 'In Progress'
          }
        };

        this.showProgressbar = true; // Show progress bar while API call is in progress
        this.notificationsService.setLoadingState(true);
        this.notificationsService.createAlert(
          ColorType.info,
          'Message received',
          'Processing in the background',
          true
        );

        this.amplifyService
          .callAPI('post', 'gsoAPI', '/jira-ms-resync', config)
          .then(response => {
            console.log('API RESPONSE:', response);
            // Start polling for the resync status using the same pattern as in gso-home
            this.pollResyncStatus(uuid);
          })
          .catch(error => {
            console.error('API Call Failed:', error);
            this.showProgressbar = false;
            this.notificationsService.setLoadingState(false);
            this.notificationsService.createAlert(
              ColorType.warn,
              'Lambda not executed successfully',
              'Please try again later',
              true
            );
          });
      } else {
        console.log('Dialog was closed without selecting a date');
      }
    });
  }

  pollResyncStatus(uuid: string): void {
    this.intervalId = setInterval(async () => {
      try {
        const statusResponse = await this.fetchMessageService.getStatus(uuid);
        console.log('Polling Status:', statusResponse);
        // Check a condition (for example, when message === 'Status deleted')
        if (statusResponse?.message === 'Status deleted') {
          clearInterval(this.intervalId);
          this.showProgressbar = false;
          this.notificationsService.setLoadingState(false);
          this.notificationsService.createAlert(
            ColorType.success,
            'Data successfully updated',
            'Please refresh the dashboard',
            true
          );
          console.log('Resync process completed successfully.');
        }
      } catch (error) {
        console.error('Failed to fetch resync status', error);
        clearInterval(this.intervalId);
        this.showProgressbar = false;
      }
    }, 10000); // Poll every 10 seconds
  }
}
